/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TransportType {
  Car = 0,
  Ship = 1,
  Air = 2,
  Train = 3,
  Other = 4,
}
